import React from 'react';

import Jumbotron from '@/components/ui/box/Jumbotron';
import JumbotronButtonArea from '@/components/ui/box/JumbotronButtonArea';
import JumbotronDescription from '@/components/ui/box/JumbotronDescription';
import JumbotronPanel from '@/components/ui/box/JumbotronPanel';
import JumbotronTitle from '@/components/ui/box/JumbotronTitle';
import Button from '@/components/ui/buttons/Button';
import ForParentsAppInformation from '@/features/registration/components/ForParentsAppInformation';

import styles from './InvitationRegisterCompleteForm.module.scss';

interface Props {
  onNavigateToLogin: () => void;
}

const InvitationRegisterCompleteForm: React.FC<Props> = ({
  onNavigateToLogin,
}) => (
  <div className={styles.page}>
    <Jumbotron>
      <JumbotronPanel panelHeaderTitle="アカウント登録完了">
        <div className={styles.panelContent}>
          <JumbotronTitle>アカウントの登録が完了しました</JumbotronTitle>
          <JumbotronDescription>
            「ログインページ」より
            <br />
            再度ログインしてご利用ください。
          </JumbotronDescription>
          <JumbotronButtonArea>
            <Button onClick={onNavigateToLogin} size="m" color="primary">
              ログインページへ
            </Button>
          </JumbotronButtonArea>
          <hr />
          <ForParentsAppInformation />
        </div>
      </JumbotronPanel>
    </Jumbotron>
  </div>
);

export default InvitationRegisterCompleteForm;
